import card from './card/index';
import cardBar from './cardBar/index';
import navMenu from './navMenu/index';
//import apiInfo from './apiInfo/index'
export default {
    card,
    'card-bar':cardBar,
    'nav-menu':navMenu,
   // 'api-info':apiInfo
}